// extracted by mini-css-extract-plugin
export var link = "SubmitError-module--link--6442c";
export var slideIn = "SubmitError-module--slideIn--3ea0e";
export var submitError = "SubmitError-module--submitError--70b93";
export var submitErrorText = "SubmitError-module--submitErrorText--dcb12";